import PropTypes from "prop-types"

const ProductDescription = ({ productName }) => {
  return (
    <p
      className="text-18 leading-20 desktop:line-clamp-1 mb-10 mt-6 hidden h-20 text-ellipsis px-16"
      title={productName}
    >
      {productName}
    </p>
  )
}

ProductDescription.propTypes = {
  productName: PropTypes.string,
}

export default ProductDescription
